import React from "react";
import lodash from "lodash";
const TableOptionsEiendomType = ({ index, handleChange, disabled }: any): JSX.Element => {
  const capitalize = lodash.capitalize(index.type);
  return (
    <div className="flex">
      <select
        className="outline-none relative flex flex-grow justify-content
                                            py-2 text-lg border border-sk-primary-blue font-medium rounded-md
                                            text-black hover:border-blue-500 focus:ring-2 focus:ring-blue-600 text-justify"
        name="type"
        title="type"
        onChange={(e) => handleChange(e, index)}
        value={capitalize}
        disabled={disabled}
      >
        <option value="Velg et alternativ her..">
          Velg et alternativ her..
        </option>
        <option value="Sanitetshus"> Sanitetshus</option>
        <option value="Barnehage"> Barnehager</option>
        <option value="Eldreboliger"> Eldreboliger</option>
        <option value="Sykehus">Sykehus</option>
        <option value="Aldershjem">Aldershjem</option>
        <option value="Annen bolig">Annen type bolig (forklar i kommentar nederst)</option>
        <option value="Annen institusjon">Annen institusjon (forklar i kommentar nederst)</option>
        <option value="Annen eiendom">Annen eiendom (forklar i kommentar nederst)</option>
      </select>
    </div>
  );
};
export default TableOptionsEiendomType;
